import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {UserService} from '../../services';
import {UserRoles} from '../../enums';

@Injectable({
    providedIn: 'root'
})
export class UserRoleGuard  {
    private userService = inject(UserService);


    canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Promise<boolean> {
        return this.userService.userHasAnyRole(route.data.roles as UserRoles[]);
    }
}
